/* eslint-disable import/extensions */
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export default function HtmlBlock({ html }) {
  if (html.includes('xtalkCon') && 'undefined' === typeof window.xtalk) {
    import('../../../../entries/responsive-iframe/index.js');
  }

  return parse(DOMPurify.sanitize(html, {
    FORBID_TAGS: ['script', 'style'],
    ADD_TAGS: ['iframe'],
  }));
}

HtmlBlock.propTypes = {
  html: PropTypes.string.isRequired,
};
